// extracted by mini-css-extract-plugin
export default {"billing_data":"Hu","delivery_details":"Iu","details_wrapper":"Ju","title":"Ku","detail_item":"Lu"};
    if(module.hot) {
      // 1711394576160
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  